export function setFancyName(fancyName) {
    return {
        type: "SET_FANCY_NAME",
        payload: fancyName
    }
}

export function setCRT(crt) {
    return {
        type: "SET_CRT",
        payload: { crt }
    }
}
export function setCNAE(cnae) {
    return {
        type: "SET_CNAE",
        payload: cnae
    }
}

export function setStateRegistry(registry) {
    return {
        type: 'SET_STATE_REGISTRY',
        payload: registry
    }
}

export function setIeIndicator(indicator) {
    return {
        type: "SET_IE_INDICATOR",
        payload: indicator
    }
}



// WEBPACK FOOTER //
// ./src/components/parts/person/personAdaptToCompany/actions.js